// import store from '@/store';

import store from '@/store';
import { onMounted, onBeforeUnmount } from "vue";
import Device from '.';
//import PowerStateWrapper from "@/helpers/Device/PowerStateWrapper";

console.log("#####################################TIZEN Device b2bapis (window):", window.hasB2bapis);
console.log("#####################################TIZEN Device webapis (window):", window.hasWebapis);

/*
const power = new PowerStateWrapper({
  onSuspend() {
    console.log("TV suspend → stop streams");
  },
  onResume() {
    console.log("TV resume → go home");
    router.replace({ name: "home" });
  },
  onVisible() {
    router.replace({ name: "home" });
  },
  onHidden() {
    console.log("TV hidden");
  },
});

onMounted(() => power.init());
onBeforeUnmount(() => power.destroy());
*/

export default class Tizen {
  static get tvwindow() {
    if (!window.tizen) return undefined;
    return window.tizen.tvwindow;
  }

  static get b2bControl() {
    if (window.b2bapis) return window.b2bapis.b2bcontrol;
    if (window.webapis) return window.webapis.systemcontrol;
    return undefined;
  }

  static get b2bPower() {
    if (window.b2bapis) return window.b2bapis.b2bpower;
    if (window.webapis) return window.webapis.remotepower;
    return undefined;
  }

  static get getModel() {
    try {
      return webapis.productinfo.getRealModel();
    } catch (error) {
      console.log('ERROR - Tizen.getModel: ', error);
      return '';
    }
  }

  static get getVersion() {
    try {
      //return webapis.productinfo.getVersion();
      return window.tizen.systeminfo.getCapabilities().platformVersion;
    } catch (error) {
      console.log('ERROR - Tizen.getVersion: ', error);
      return '';
    }
  }

  static get getIP() {
     return webapis.network.getIp();
  }

  static get getMac() {
    try {
      return webapis.network.getMac();
    } catch (error) {
      console.log('ERROR - Tizen.getMac: ', error);
      return '00:00:00:00:00';
    }
  }
  static get getFirmware() {
    try {
      return webapis.productinfo.getFirmware();
    } catch (error) {
      console.log('ERROR - Tizen.getFirmware: ', error);
      return '';
    }
  }
  static get getPlatform() {
    try {
      return window.tizen.systeminfo.getCapability(
        'http://tizen.org/feature/platform.version'
      );
    } catch (error) {
      console.log('ERRROR: Tizen.getPlatform', error);
      return '';
    }
  }
  static get getSerial() {
    try {
      console.log("======================================================getSERIAL", this.b2bControl.getSerialNumber());
      return this.b2bControl.getSerialNumber();
    } catch (error) {
      console.log(' error code = ' + error.code);
      return '';
    }
  }
  static getResolutionHeight() {
    return screen.height;
  }
  static getResolutionWidth() {
    return screen.width;
  }

  /*
  static set setSystemConfig(value) {
    try {
      webapis.productinfo.setSystemConfig(webapis.productinfo.ProductInfoConfigKey.CONFIG_KEY_DATA_SERVICE, value, onsuccess, onerror);
      return true;
    } catch (error) {
      console.log("ERRROR: Tizen setSystemConfig data = " + error.code);
      return false;
    }
  }

  static onsuccess(data)  {
    console.log("SUCCESS: Tizen setSystemConfig data = " + data);
  }
  static onerror(error)  {
    console.log("error code : " + error.code);
  }
  */

  static PowerState() {
    try {
      const PowerState = this.b2bPower.getPowerState();
      store.dispatch('notification/new', {
        title: 'Power State',
        message: PowerState,
      });
    } catch (e) {
      store.dispatch('notification/new', {
        title: e.name,
        message: e.message,
      });
      console.log(
        '[getPowerState] call syncFunction exception [' +
          e.code +
          '] name: ' +
          e.name +
          ' message: ' +
          e.message
      );
    }
  }
  static callbackSuccess(name, context) {
    console.log('CALLBACK_SUCCESS: ', name, ' with context: ', context);
  }
  static callbackError(name, context) {
    console.log('CALLBACK_ERROR: ', name, ' with context: ', context);
  }
  static turnOff() {
    const cbSuccess = () => this.callbackSuccess('turnOff');
    const cbError = () => this.callbackError('turnOff');
    //console.log('=================================================Turning off TV - hasWebapis', hasWebapis);
    //console.log('=================================================Turning off TV - hasB2bapis', hasB2bapis);
    if(window.b2bapis) {
      console.log('=================================================Turning off TV - b2bControl', this.b2bControl);
      this.b2bControl.setPowerOff(cbSuccess, cbError);
    } else if(window.webapis) {
      console.log('=================================================Turning off TV - webapis.remotepower');
      window.webapis.remotepower.powerOff();
    }
  }
  static turnOn() {
    const cbSuccess = () => this.callbackSuccess('turnOn');
    const cbError = (err) => this.callbackError('turnOn', err);
    if(window.b2bapis) {
      console.log('=================================================Turning on TV - b2bPower', this.b2bPower);
      this.b2bPower.setPowerOn(cbSuccess, cbError);
    } else if(window.webapis) {
      console.log('=================================================Turning on TV - webapis.remotepower');
      window.webapis.remotepower.powerOn();
    }
  }

  static reboot() {
    const cbSuccess = () => this.callbackSuccess('reboot');
    const cbError = (err) => this.callbackError('reboot', err);
    this.b2bControl.rebootDevice(cbSuccess, cbError);
  }
}



// WEBPACK FOOTER //
// ./src/helpers/Device/Tizen.js